import React from 'react';
import { connect } from 'react-redux';
import Moment from 'moment';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import withStyles from '@material-ui/core/styles/withStyles';
import buttonsStyle from 'assets/jss/material-dashboard-pro-react/views/buttonsStyle.jsx';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';

import SummaryDay from './SummaryDay';

class SummaryContent extends React.Component {
  render() {
    const { mealTypes, diets, classes, t, loading } = this.props;
    const hasPrefetchedMenuPlanners = Array.isArray(this.props.menuPlanners);
    const prefetchedMenuPlannersByDay = {};

    if (this.props.variant === '') {
      return null;
    }

    if (loading) {
      return null;
    }

    if (hasPrefetchedMenuPlanners) {
      this.props.menuPlanners.forEach(menuPlanner => {
        if (!menuPlanner) {
          return;
        }

        const day = new Moment(menuPlanner.date).format('YYYY-MM-DD');

        if (!prefetchedMenuPlannersByDay[day]) {
          prefetchedMenuPlannersByDay[day] = [];
        }

        prefetchedMenuPlannersByDay[day].push(menuPlanner);
      });
    }

    return (
      <GridContainer>
        <GridItem xs={12}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell
                  padding="dense"
                  style={{ borderBottom: 0 }}
                  colSpan={1}
                />
                {diets.map((diet, index) => (
                  <TableCell
                    colSpan={1}
                    key={index}
                    align="center"
                    padding="dense"
                  >
                    {diet.name}
                    {!diet.active && (
                      <>
                        <br />{' '}
                        <span style={{ color: '#bebebe' }}>
                          {t('menuPlanner.dietInactive', '(Dieta nieaktywna)')}
                        </span>
                      </>
                    )}
                  </TableCell>
                ))}
              </TableRow>
              {this.props.dates.map(day => (
                <SummaryDay
                  key={day}
                  day={day}
                  diets={diets}
                  {...(hasPrefetchedMenuPlanners
                    ? {
                        menuPlanners: prefetchedMenuPlannersByDay[day] || [],
                      }
                    : {})}
                  variant={this.props.variant}
                  mealTypes={mealTypes}
                />
              ))}
            </TableHead>
          </Table>
        </GridItem>
      </GridContainer>
    );
  }
}

const mapStateToProps = state => ({
  mealTypes: state.MealTypes.mealTypes,
});

const enhance = compose(
  connect(mapStateToProps, null),
  withStyles(buttonsStyle),
  withTranslation()
);

export default enhance(SummaryContent);
